import React, { createContext, useState, useContext } from 'react';
import { Data } from '../types/table.types';

interface TableDataContextType {
  tableData: Data[];
  setTableData: React.Dispatch<React.SetStateAction<Data[]>>;
  lastFetchTime: number;
  setLastFetchTime: React.Dispatch<React.SetStateAction<number>>;
}

const TableDataContext = createContext<TableDataContextType | undefined>(undefined);

export const TableDataProvider: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
  const [tableData, setTableData] = useState<Data[]>([]);
  const [lastFetchTime, setLastFetchTime] = useState<number>(0);

  return (
    <TableDataContext.Provider value={{ tableData, setTableData, lastFetchTime, setLastFetchTime }}>
      {children}
    </TableDataContext.Provider>
  );
};

export const useTableData = () => {
  const context = useContext(TableDataContext);
  if (context === undefined) {
    throw new Error('useTableData must be used within a TableDataProvider');
  }
  return context;
};
